import { useRef } from "react";
import store from "../../store/store";
import Button from "../common/Button";
import Player from "../Players/Player";
import { Sentence } from "../../models/Sentence";
import { gameActions } from "./gameSlice";
import classNames from 'classnames';
import { PlayerPublic } from "../../models/Player";
import { GameStatus } from "../../models/GameStatus";
import { previewActions } from "../Card/previewSlice";

function GameVote() {
  const gameState = store.getState().game;
  const userState = store.getState().user;
  const player = gameState.player;
  const winners = gameState.winners;
  const players = gameState.players;

  const finishButtonRef = useRef<HTMLDivElement>(null);

  const sentenceVoteFinished = gameState.player?.data.hasSentenceVoteFinished;

  function finishVoting() {
    if (player) {
      store.dispatch(gameActions.submitGameVoteFinished({
        gameId: gameState.gameId,
        playerId: player.data.playerId,
      }));
    }
  }

  function sentenceVote(sentence: Sentence) {
    if (player) {
      store.dispatch(gameActions.submitGameVoteToggle({
        gameId: gameState.gameId,
        playerId: player.data.playerId,
        sentence: sentence.card as string
      }));
    }
  }

  function scrollToFinish() {
    finishButtonRef.current?.scrollIntoView({ behavior: 'smooth' });
  }

  const winnerNames: string[] = [];

  players.forEach((it) => {
    if (winners.includes(it.playerId)) {
      winnerNames.push(it.username);
    }
  });

  function generateImagePath(imageName: string | undefined) {
    return `${gameState.settings?.cardsHost}${imageName}`;
  }

  function previewCards(card: string | undefined, reversedSentences: Sentence[]) {
    if (!card) {
      return;
    }

    store.dispatch(previewActions.showPreview({
      card: { src: generateImagePath(card) }
    }));
  }

  function isPlayerPending(playerPublic: PlayerPublic | undefined, isClient: boolean = false) {

    if (!playerPublic) {
      return false;
    }

    return gameState.status === GameStatus.GAME_SENTENCE_VOTE
      && !playerPublic.hasSentenceVoteFinished;
  }

  const pendingPlayers = players.filter(it => isPlayerPending(it));

  const finishVotingButton = (
    <div className="game-vote_buttons" ref={finishButtonRef}>
      <Button
        text={'Finish voting'}
        onClick={() => finishVoting()}
        disabled={sentenceVoteFinished}
        confirmPrompt={userState.user.confirmActionEnabled ? `Are you sure you want to finish voting?` : null}
      />
    </div>
  );

  return (
    <div className="game-vote">

      {/* {finishVotingButton} */}

      <div className="game-vote_winners">
        <div className="game-vote_winners-title">{winners && winners.length > 1 ? 'Winners' : 'Winner'}: </div>
        <div className="game-vote_winners-list">
          {winnerNames.join(", ")}
        </div>
        <div className="game-vote_subheader">please vote ❤️ for the best sentences</div>
        <div className="game-vote_subheader pointer" onClick={scrollToFinish}><i>then finish the game</i> ↓</div>
      </div>

      <div className="game-vote_players">
        {players.map(it => {
          const reversedSentences = [...it?.sentences].reverse();
          const classes = classNames({
            'player_leading': winners.includes(it.playerId),
          });

          const isClient = it.playerId === player?.data.playerId;
          const votingEnabled = !isClient && !player?.data.hasSentenceVoteFinished;
          const isPending = isPlayerPending(it);
          const isLastPending = isClient && isPending && pendingPlayers.length === 1

          return <div className="game-vote_player" key={it.playerId}>
            <Player
              size={46}
              player={it}
              classes={classes}
              isPending={isPending}
              isClient={isClient}
              isLastPending={isLastPending}
              emoji={it.emoji}
            />
            <div className="player-sentences">
              {reversedSentences.map((sentence, i) => {

                const sentenceClasses = classNames({
                  'sentence-vote': true,
                  'sentence-vote_active': votingEnabled,
                  'sentence-vote_disabled': !votingEnabled,
                  'sentence-vote_voted-players': sentence.likedPlayers && sentence.likedPlayers.length > 0,
                  'sentence-vote_voted-client': sentence.likedPlayers?.includes(player?.data.playerId || ''),
                });

                return <div key={i}>
                  <div className={sentenceClasses}>
                    <span className="sentence-vote_button" onClick={votingEnabled ? () => sentenceVote(sentence) : undefined}>❤️
                      <span className="sentence-vote_number">{`${sentence.likedPlayers?.length}`}</span>
                    </span>

                    <a onClick={() => previewCards(sentence.card, reversedSentences)} className="sentence-vote_text">"{sentence.sentence}" [{sentence.score}]</a>
                    <div className="stats_sentence_explanation">{sentence.sentenceExplanation}</div>
                  </div>
                </div>
              }
              )}
            </div>
          </div>
        })}
      </div>

      {finishVotingButton}

    </div>
  )
}

export default GameVote;